import { Component } from "react";
import '../IpPatientDetails.css';
import {
    Box, Paper, TextField, Button, Stack, Tooltip, Grid, IconButton,
    Autocomplete, Typography, Menu, MenuItem, ListItem, ListItemText, Divider, Modal
} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import CommonGridHeader, {
    CommonPatientDetails, CommonPatientCard, ConsultantPatientCard,
    CommonEditButton, CommonPopUp, ReasonPopup, DeletePopup, HighAlertDrugPopup
} from "../../../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../../../Components/CommonFunctions/CommonValidation";
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { Colors } from "../../../../../Styles/Colors";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import { getCachevalue, localGetItem } from "../../../../../Utility/Services/CacheProviderService";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IP_routeList, Medication_dosages } from '../../../../../Utility/Constants';
import { CheckAccessFunc, formatDateAndTimeMeth2, debounce } from "../../../../../Components/CommonFunctions/CommonFunctions";
import Loader from '../../../../../Components/Loader';
import { DateTime } from "luxon";
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';

const multi_option = [
    { value: "Start", label: "Start", color: "#E3FFE6" },
    { value: "Stop", label: "Stop", color: "#FFE3E3" },
    { value: "Hold", label: "Hold", color: "#FFF8BC" },
    { value: "Completed", label: "Completed", color: "#FFFFFF" },
    { value: "view_log", label: "View Log", color: "" },
];

const titleMap = {
    Add: "Add New Template",
    rename: "Rename Template",
    delete: "Delete Template",
};

class DrugChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tblData: [],
            patientData: {},
            attenderData: {},
            brandnameList: [],
            genericList: [],
            pharmaData: [],
            pharma_name: "",
            pharma_id: null,
            drug_date: dayjs(),
            drug_ms_id: "",
            drug_name: "",
            externalBrandName: "",
            generic_name: "",
            externalGenName: "",
            dosage_type: "",
            externalDosageType: "",
            dosage_strength: "",
            externalDosStrength: "",
            route: "",
            externalRoute: "",
            quantity: null,
            external_quantity: null,
            frequency: "",
            external_frequency: "",
            instruction: "",
            external_instruction: "",
            selectedRow: null,
            isSelected: false,
            anchorEl: null,
            focusError: "",
            current_page: 0,
            rowsPerPage: 10,
            selectedMenu: "",
            viewLogData: [],
            isAdd: false,
            isEdit: false,
            withOutAppointment: {},
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
            selectedData: {},
            ExternalDrug: false,
            ExternalDrugList: [],
            genericSuggList: [],
            Nurse: {
                "nurse": "",
                "staff_id": ""
            },
            NurseList: [],
            drug_search: '',
            fo_external_drug_id: null,
            templateList: [],
            selectedTemplateName: null,
            openPopupAddNew: false,
            templateName: '',
            tempType: '',
            templateLoad: false,
            deleteTemplateName: {},
            deletePopup: false,
            deleteLoad: false,
            renameTemplateName: {},
            selectedDrug: '',
            is_high_alert: false,
            is_look_alike: false,
            is_sound_alike: false,
            highAlert: false,
            lookAlikeDrugs: [],
            SoundAlikeDrugs: [],
            highAlertData: null,
            enable_drug_alert: false,
        }
        this.dobounceApiSearch = debounce(this.getExternalDrugSearchList, 500)
        this.debounceBrandName = debounce(this._getBrandList, 500)
    }
    componentDidMount() {
        let patientDetails = getCachevalue("IppatientData")
        let patients = patientDetails ? JSON.parse(patientDetails) : null
        let appointmentDetail = getCachevalue("withoutAppointment");
        let details = appointmentDetail ? JSON.parse(appointmentDetail) : null;
        let drugSearch = localGetItem('drug_search') !== 'undefined' && localGetItem('drug_search') !== null ? JSON.parse(localGetItem('drug_search')) : 1;
        let enable_drug_alert = localGetItem('enable_drug_alert') ? JSON.parse(localGetItem('enable_drug_alert')) : false;
        this.setState({ drug_search: drugSearch, enable_drug_alert: enable_drug_alert })
        this._getPharmaList();
        this.getNurseList();
        this.setState(
            {
                patientData: patients,
                ...(details?.patient_id === patients?.patient_id && { withOutAppointment: details }),
            }, () => {
                this.getIpDrugChartDetails();
                this.getPatientData();
                this.getTemplateList();
            }
        );
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    GetIpAdmissionId = () => {
        return this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id || this.state.patientData?.ip_admission_id || (() => { try { const j = JSON.parse(getCachevalue('IppatientData') || 'null'); return j?.id || j?.ip_admission_id } catch { return null } })() || null;
    }

    getPatientData = () => {
        this.setState({
            attenderData: {}
        })
        let admission_id = this.GetIpAdmissionId();
        let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
        if (this.props.is_From_IpNotes && this.state.clinic_id) {
            url = `${url}&clinic_id=${this.state.clinic_id}`
        }
        try {
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            attenderData: response.data.data[0]
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMsgFunc(error.response.data.message)
                    } else {
                        this.errorMsgFunc(error.message)
                    }
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    getIpDrugChartDetails = () => {
        let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DRUG_CHART}?ip_admission_id=${admission_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let data = response.data.data?.map((item, i) => {
                            return { ...item, index: i };
                        }) || [];
                        this.setState({
                            tblData: data || [],
                        });
                    }
                })
                .catch(error => {
                    this.errorMsgFunc(error.response.data.message || error.message);
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }

    getTemplateList = () => {
        try {
            let url = Serviceurls.IP_DRUG_CHART_TEMPLATE;
            if (this.props.is_From_IpNotes && this.state.clinic_id) {
                url = `${url}?clinic_id=${this.state.clinic_id}`
            }
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            templateList: response?.data?.data || [],
                        });
                    }
                }).catch((error) => {
                    this.errorMsgFunc(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    _getPharmaList = () => {
        this.setState({
            pharmaData: []
        })
        try {
            let url = Serviceurls.FO_IP_PHARMALIST_GET;
            if (this.props.is_From_IpNotes && this.state.clinic_id) {
                url = `${url}?clinic_id=${this.state.clinic_id}`
            }
            RestAPIService.getAll(url)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            pharmaData: response.data.data,
                            pharma_name: response.data.data[0].pharmacy_name,
                            pharma_id: response.data.data[0].pharmacy_id
                        });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMsgFunc(error.response.data.message);
                    }
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }

    getNurseList = () => {
        try {
            let url = Serviceurls.FO_STAFF_LIST;
            if (this.props.is_From_IpNotes && this.state.clinic_id) {
                url = `${url}?clinic_id=${this.state.clinic_id}`
            }
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            NurseList: response.data.data
                        }, () => {
                            if (this.state.NurseList?.length && localGetItem("NurseId") && !this.state?.Nurse?.staff_id) {
                                let nurseId = JSON.parse(localGetItem("NurseId"))
                                let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                                this.setState({
                                    Nurse: nurseData
                                })
                            }
                        })
                    }
                }).catch((error) => {
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    _getBrandDetails = (brandName, genericName) => {
        let list = [];
        this.setState({
            genericList: []
        })
        let params = ''
        if (+this.state.drug_search === 1) {
            params = `${Serviceurls.FO_IP_BRANDDETAILS_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&drug_name=${encodeURIComponent(brandName)}`
        } else {
            params = `${Serviceurls.FO_IP_BRANDDETAILS_GET}?pharmacy_id=${this.state.pharma_id ? this.state.pharma_id : null}&drug_name=${encodeURIComponent(brandName)}&generic_name=${encodeURIComponent(genericName)}`
        }
        try {
            RestAPIService.getAll(params)
                .then(response => {
                    if (response.data.status === "success") {
                        list = [...response.data.data];
                        const hasHighAlert = list.some(item => (item.is_high_alert === true || item.is_look_alike === true || item.is_sound_alike === true));
                        if (hasHighAlert && this.state.enable_drug_alert) {
                            this.setState({
                                selectedDrug: list[0]['drug_name'] || '',
                                is_high_alert: list[0]['is_high_alert'] || false,
                                is_look_alike: list[0]['is_look_alike'] || false,
                                is_sound_alike: list[0]['is_sound_alike'] || false,
                                lookAlikeDrugs: list[0]['look_alike_drugs'] || [],
                                SoundAlikeDrugs: list[0]['sound_alike_drugs'] || [],
                                highAlertData: { brandName, genericName, list },
                            },() => {
                                this.setState({
                                    highAlert: true
                                })
                            });
                            return;
                        }
                        this.handleBrandDetailsResponse(list);
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMsgFunc(error.response.data.message);
                    }
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }

    handleBrandDetailsResponse = (list) => {
        if (list.length === 1) {
            this.setState({
                drug_ms_id: list[0]["drug_ms_id"],
                generic_name: list[0]["generic_name"],
                dosage_type: list[0]["dosage_type"],
                dosage_strength: list[0]["drug_strength"],
            });
        } else {
            this.setState({ genericList: list });
        }
    };

    _getBrandList = (brand_name) => {
        this.setState({
            brandnameList: []
        })
        let params = ''
        if (+this.state.drug_search === 1) {
            params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id || null}&brand_name=${encodeURIComponent(brand_name)}`
        } else if (+this.state.drug_search === 2) {
            params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id || null}&brand_name=&generic_name=${encodeURIComponent(brand_name)}`
        } else {
            params = `${Serviceurls.FO_IP_BRANDNAMELIST_GET}?pharmacy_id=${this.state.pharma_id || null}&brand_name=&generic_name=&search_key=${encodeURIComponent(brand_name)}`
        }
        if (brand_name && this.state.pharma_id) {
            try {
                RestAPIService.getAll(params)
                    .then(response => {
                        if (response.data.status === "success") {
                            let data = response.data.data
                            let uniqueArray = data?.filter((item, index, self) =>
                                index === self.findIndex((t) => (
                                    t.drug_name === item.drug_name
                                ))
                            );
                            this.setState({ brandnameList: uniqueArray });
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.errorMsgFunc(error.response.data.message);
                        }
                    });
            } catch (e) {
                this.errorMsgFunc(e.message);
            }
        }
    }

    _getLogDetails = (rowId) => {
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DRUG_CHART_HISTORY}?id=${rowId}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            viewLogData: response.data.data,
                        });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMsgFunc(error.response.data.message);
                    }
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }
    getExternalDrugSearchList = (brandName, genericName) => {
        try {
          RestAPIService.getAll(Serviceurls.DOC_OPT_EXTERNAL_DRUG + `?brand_name=${brandName}&generic_name=${genericName}`)
            .then((response) => {
              if (response.data.status === 'success') {
                this.setState({
                  dupExternalDrugList: response?.data?.data ? response?.data?.data : []
                }, () => {
                  const uniqueDrugsObj = this.state.dupExternalDrugList.reduce((acc, drug) => {
                    const key = drug?.drug_name?.trim().toUpperCase(); // Normalize drug_name
    
                    if (!acc[key]) {
                      acc[key] = {
                        drug_name: drug.drug_name,
                        generic_name: [
                          {
                            generic_name: drug.generic_name,
                            dosage_type: drug.dosage_type,
                            dosage_strength: drug.dosage_strength,
                            fo_external_drug_id: drug.fo_external_drug_id
                          }
                        ]
                      };
                    } else {
                      const existingGeneric = acc[key].generic_name?.find(
                        (g) => g.generic_name === drug.generic_name &&
                          g.dosage_type === drug.dosage_type &&
                          g.dosage_strength === drug.dosage_strength
                      );
    
                      if (!existingGeneric) {
                        acc[key].generic_name.push({
                          generic_name: drug.generic_name,
                          dosage_type: drug.dosage_type,
                          dosage_strength: drug.dosage_strength
                        });
                      }
                    }
                    return acc;
                  }, {});
    
                  const uniqueDrugsArray = Object.values(uniqueDrugsObj);
    
                  this.setState({
                    ExternalDrugList: uniqueDrugsArray
                  }, () => {
                    if (this.state.isEdit) {
                      let genericSuggList = this.state.ExternalDrugList?.find((item) => item?.drug_name === this.state.externalBrandName)
                      this.setState({
                        genericSuggList: genericSuggList ? genericSuggList?.generic_name : []
                      })
                    }
                  });
                });
              }
            }).catch((error) => {
              if (error?.response?.data?.message) {
                this.errorMsgFunc(error.response.data.message, false)
              } else {
                this.errorMsgFunc(error.message, false)
              }
            })
        } catch (error) {
          this.errorMsgFunc(error.message, false)
        }
      }
      

    handleFocus = () => {
        const { t } = this.props;
        let { pharma_name } = this.state;
        if (pharma_name === "") {
            this.setState({ focusError: "Select Pharmacy" });
            this.errorMsgFunc(t("SelectPharmacy"));
        }
    }

    highAlertpopupConfirm = () => {
        const { highAlertData } = this.state;
        if (highAlertData?.list) {
            this.handleBrandDetailsResponse(highAlertData.list);
        }
        this.setState({
            highAlert: false,
            highAlertData: null,
        });
    }

    highAlertpopupClose = () => {
        this.setState({
            highAlert: false,
            highAlertData: null,
            drug_name: "",
            externalBrandName: "",
            generic_name: "",
            externalGenName: "",
            dosage_type: "",
            externalDosageType: "",
            dosage_strength: "",
            externalDosageType: "",
        })
    }

    errorMsgFunc = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            isAdd: false,
            selectedRow: {},
            selectedMenu: "",
        })
    }

    successMsgFunc = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            isAdd: false,
            selectedRow: {},
            selectedMenu: "",
        })
    }

    handleClear = () => {
        this.setState(
            {
                pharma_name: "",
                pharma_id: null,
                drug_date: dayjs(),
                drug_ms_id: "",
                drug_name: "",
                externalBrandName: "",
                generic_name: "",
                externalGenName: "",
                dosage_type: "",
                externalDosageType: "",
                dosage_strength: "",
                externalDosageType: "",
                route: "",
                externalRoute: "",
                quantity: null,
                external_quantity: null,
                frequency: "",
                external_frequency: "",
                instruction: "",
                external_instruction: "",
                isAdd: false,
                isEdit: false,
                selectedData: {},
                ExternalDrug: false,
                externalDosStrength: "",
                Nurse: {
                    "nurse": "",
                    "staff_id": ""
                },
                fo_external_drug_id: null,
            }, () => {
                if (this.state.NurseList?.length && localGetItem("NurseId")) {
                    let nurseId = JSON.parse(localGetItem("NurseId"))
                    let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                    this.setState({
                        Nurse: nurseData
                    })
                }
                this._getPharmaList()
            }
        )
    }

    formatDate = (date) => {
        const dt = DateTime.fromJSDate(new Date(date));
        return dt.toFormat(`yyyy-MM-dd HH:mm:ss`);
    };
    

    handleAdd = (drugStatus = 'Start', reason = "", templateData = []) => {
        try {
            let states = this.state;
            let isDataAvailable = this.checkDataPresence();
            if (isDataAvailable || states.selectedMenu || templateData?.length > 0) {
                const doctorId = drugStatus ? (states?.selectedRow?.doctor_id || states?.patientData?.doctor_id) :
                    states?.isEdit ? (states?.selectedData?.doctor_id || states?.patientData?.doctor_id) :
                        states?.patientData?.doctor_id
                let data = {
                    'ip_admission_id': states?.patientData?.id,
                    "doctor_id": doctorId,
                    'date': states?.drug_date ? this.formatDate(states?.drug_date)
                        : states.selectedRow?.date ?
                            this.formatDate(states?.selectedRow?.date) : null,
                    'drug_name': states?.drug_name ? states?.drug_name : states.externalBrandName ?  states.externalBrandName  :  states.selectedRow?.drug_name ?
                        states?.selectedRow?.drug_name : "",
                    'generic_name': states?.generic_name ? states?.generic_name : states.externalGenName ? states.externalGenName : states.selectedRow?.generic_name ?
                        states?.selectedRow?.generic_name : "",
                    'dosage_strength': states?.dosage_strength ? states?.dosage_strength : states.externalDosStrength ? states.externalDosStrength : states.selectedRow?.dosage_strength ?
                        states?.selectedRow?.dosage_strength : "",
                    'dosage_type': states?.dosage_type ? states?.dosage_type : states.externalDosageType ? states.externalDosageType : states.selectedRow?.dosage_type ?
                        states?.selectedRow?.dosage_type : "",
                    'route': states?.route ? states?.route : states.externalRoute ? states.externalRoute : states.selectedRow?.route ?
                        states?.selectedRow?.route : "",
                    'quantity': states?.quantity ? states?.quantity : states.external_quantity ? states.external_quantity : states.selectedRow?.quantity ?
                        states?.selectedRow?.quantity : "",
                    'frequency': states?.frequency ? states?.frequency : states.external_frequency ? states.external_frequency  :  states.selectedRow?.frequency ?
                        states?.selectedRow?.frequency : "",
                    'instruction': states?.instruction ? states?.instruction : states.external_instruction ? states.external_instruction  : states.selectedRow?.instruction ?
                        states?.selectedRow?.instruction : "",
                    'status': states?.isEdit ? states?.selectedData?.status : drugStatus,
                    'comments': reason ? reason : undefined,
                    "status_update": states.selectedMenu ? true : false,
                    "nurse_profile_id": states.Nurse?.staff_id || null,
                }
                if(this.state.ExternalDrug){
                    data["is_external_drug"] = true
                    data["fo_external_drug_id"] = states.fo_external_drug_id || null;
                }

                if (states?.isEdit || states.selectedMenu) { data["id"] = states?.selectedData?.id || states?.selectedRow?.id }

                const payload = {
                    "doctor_id": doctorId,
                    records: templateData?.length > 0 ? templateData : [data]
                }
                RestAPIService.create(payload, Serviceurls.IP_DRUG_CHART)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.handleClear()
                            this.getIpDrugChartDetails()
                            this.successMsgFunc(response.data.message)
                        } else {
                            this.errorMsgFunc(response.data.message)
                        }
                    }).catch(error => {
                        this.errorMsgFunc(error.response.data.message || error.message)
                    })
            }
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    DisableRouteOption = (option, IP_routeList) => {
        let Dosage_Type = this.state.dosage_type
        if (Dosage_Type === "Ampules" || Dosage_Type === "Injection") {
            return (
                option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[7] || option === IP_routeList[8] || option === IP_routeList[9] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
            )
        } else if (Dosage_Type === "Tablet") {
            return (
                option === IP_routeList[0] || option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[9] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
            )
        } else if (Dosage_Type === "Steroid Tablets" || Dosage_Type === "Capsule Sr" || Dosage_Type === "Syrup" || Dosage_Type === "Biscuit") {
            return (
                option === IP_routeList[0] || option === IP_routeList[3] || option === IP_routeList[4] || option === IP_routeList[5] || option === IP_routeList[6] || option === IP_routeList[8] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[9] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
            )
        } else if (Dosage_Type === "Capsule") {
            return (
                option === IP_routeList[0] || option === IP_routeList[1] || option === IP_routeList[2] || option === IP_routeList[3] || option === IP_routeList[8] || option === IP_routeList[9] || option === IP_routeList[6] || option === IP_routeList[10] || option === IP_routeList[11] || option === IP_routeList[12]
            )
        }
    }

    handleChange = (e) => {
        let { name, value } = e.target;
        let isValid = false;
        let states = this.state;
        value = value.trimStart();
        switch (name) {
            case "quantity":
                isValid = CommonValidation.NumberWithDot(value);
                if ((isValid && value.length <= 4) || value == "") {
                    states.quantity = value;
                }
                break;
            case "instruction":
                if (value?.length <= 250) {
                    states[name] = value;
                }
                break;
            default:
                states[name] = value;
                break;
        }
        this.setState({ states })
    }

    renderTextBox(label, statekey, value, isDisabled = false, isFromExternal = false) {
        const { t } = this.props;
        let states = this.state
        let { brandnameList, drug_name, genericList, pharmaData, focusError } = this.state;
        let updatedState = { ...this.state };
        return (
            <div>
                {statekey === "pharma_name" ?
                    <Autocomplete
                        disableClearable
                        value={value ? value : ""}
                        sx={{ width: "13.6vw", fontSize: "0.9vw" }}
                        inputProps={{'emed_tid': 'drg_pharma_name' }}
                        size="small"
                        options={pharmaData?.length > 0 ? [...pharmaData] : []}
                        getOptionLabel={option => typeof (option) === "string" ? option : option.pharmacy_name}
                        onChange={(event, newPharma) => {
                            this.setState({
                                pharma_name: newPharma?.pharmacy_name,
                                pharma_id: newPharma?.pharmacy_id,
                                focusError: "",
                            })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={`${t(label)} (${pharmaData?.length || 0}) *`}
                                autoComplete="off"
                                size="small"
                                InputProps={{
                                    ...params.InputProps,
                                }}
                                error={value === "" && focusError?.length > 0}
                            />
                        )}
                    />
                    : (statekey === "drug_name") || (statekey === "externalBrandName") ?
                        <Autocomplete
                            disableClearable
                            clearIcon = {statekey === "externalBrandName" && true}
                            freeSolo = {statekey === "externalBrandName" && true}
                            autoSelect={statekey === "externalBrandName" && false}
                            value={value || null}
                            sx={{ width: "13.6dvw" }}
                            size="small"
                            options={statekey === "externalBrandName" ? this.state.ExternalDrugList ? this.state.ExternalDrugList : [] : brandnameList?.length != 0 ? [...brandnameList] : []}
                            inputProps={{'emed_tid': 'drg_drug_name' }}
                            getOptionLabel={option => typeof (option) === "string" ? option :
                                statekey === "externalBrandName" ? option.drug_name :
                                    // typeof option === 'object' ? option.drug_name || '' : option}
                                   typeof option === 'object' ? (+this.state.drug_search === 1 ? option.drug_name : `${option.drug_name} ${option?.generic_name ? `- ${option?.generic_name}` : ''}`) : option}
                            onChange={(event, value) => {
                                if(statekey === "externalBrandName"){
                                    this.setState({
                                        externalBrandName: value?.drug_name,
                                        externalGenName: '',
                                        externalDosageType: '',
                                        externalDosStrength: '',
                                        externalRoute: '',
                                      }, () => {
                                        if (value?.generic_name?.length === 1) {
                                          this.setState({
                                            externalGenName: value?.generic_name[0]?.generic_name,
                                            externalDosStrength: value?.generic_name[0]?.dosage_strength,
                                            externalDosageType: value?.generic_name[0]?.dosage_type,
                                            fo_external_drug_id: value?.generic_name[0]?.fo_external_drug_id,
                                          })
                                        } else {
                                          this.setState({
                                            genericSuggList: value?.generic_name ? value?.generic_name : []
                                          })
                                        }
                                      })

                                }else{
                                    this.setState({
                                        drug_name: value?.drug_name
                                    }, () => {
                                        this._getBrandDetails(value?.drug_name, value?.generic_name);
                                    })
                                }
                              
                            }}
                            onInputChange={(event, newBrand) => {
                                if(statekey === "drug_name"){
                                    let previousBrand_name = JSON.stringify(drug_name);
                                    if (drug_name !== newBrand) {
                                        updatedState.drug_name = ''
                                    };
                                    if (previousBrand_name != JSON.stringify(newBrand)) {
                                        updatedState.drug_ms_id = null;
                                        updatedState.generic_name = "";
                                        updatedState.dosage_type = "";
                                        updatedState.dosage_strength = "";
                                    }
                                    this.setState({
                                        updatedState,
                                        genericList: previousBrand_name != JSON.stringify(newBrand) ? [] : [...this.state.genericList]
                                    })
                                    this.debounceBrandName(newBrand);
                                }
                               
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t(label) + "*"}
                                    autoComplete="off"
                                    size="small"
                                    onChange={(e) => {
                                        if(statekey === "externalBrandName"){
                                            if (e.target.value?.length > 0) {
                                                states.externalBrandName = e.target.value
                                                this.setState({
                                                  states
                                                }, () => this.dobounceApiSearch(e.target.value, ''))
                                              } else {
                                                this.setState({
                                                  dupExternalDrugList: [],
                                                  ExternalDrugList: [],
                                                  externalBrandName: '',
                                                  externalGenName: '',
                                                  externalDosageType: '',
                                                  externalDosStrength: '',
                                                  externalRoute: '',
                                                  fo_external_drug_id: null,
                                                })
                                              }

                                        }                                      }}
                                    InputProps={{
                                        ...params.InputProps,
                                    }}
                                    onFocus={statekey === "drug_name" && this.handleFocus}
                                />
                            )}
                        />
                        : (statekey === "generic_name") || (statekey === "externalGenName") ?
                            <Autocomplete
                                disableClearable
                                value={value ? value : ""}
                                sx={{ width: "13.6dvw" }}
                                size="small"
                                freeSolo ={statekey === "externalGenName" && true}
                                autoSelect={statekey === "externalGenName"  && false}
                                options={ (statekey === "externalGenName") ? this.state.genericSuggList ? this.state.genericSuggList : [] :genericList?.length != 0 ? [...genericList] : []}
                                inputProps={{ 'emed_tid': 'drg_generic_name' }}
                                getOptionLabel={option => typeof (option) === "string" ? option :(statekey === "externalGenName") ?  option.generic_name : option.display_name}
                                onChange={(event, newGeneric) => {
                                    if((statekey === "externalGenName")){
                                        this.setState({
                                            externalGenName: newGeneric ?.generic_name,
                                            externalDosStrength: newGeneric ?.dosage_strength,
                                            externalDosageType: newGeneric ?.dosage_type,
                                          })

                                    }else{
                                        this.setState({
                                            drug_ms_id: newGeneric.drug_ms_id,
                                            generic_name: newGeneric.generic_name,
                                            dosage_type: newGeneric.dosage_type,
                                            dosage_strength: newGeneric.drug_strength,
                                        })
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={t(label)}
                                      autoComplete="off"
                                      size="small"
                                      onChange={(e) => {
                                        if (statekey === "externalGenName") {
                                          this.setState({
                                            externalGenName: e.target.value
                                          });
                                        }
                                      }}
                                      onFocus={statekey === "externalGenName" ? this.handleFocus : undefined}
                                    />
                                  )}
                            />
                            :
                            statekey === "externalDosageType" ?
                                    <Autocomplete
                                      disableClearable
                                      value={value ? value : ""}
                                      sx={{   width : "13.4vw" }}
                                      size="small"
                                      options={Medication_dosages}
                                      getOptionLabel={option => typeof (option) === "string" ? option : option?.label}
                                      onChange={(event, newRoute) => {
                                        this.setState({
                                            externalDosageType : newRoute?.label
                                        })
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(label)}
                                          autoComplete="off"
                                          size="small"
                                          InputProps={{
                                            ...params.InputProps,
                                          }}
                                        />
                                      )}
                                    />
                            :  (statekey === "route") || (statekey === "externalRoute")  ?
                                <Autocomplete
                                    disableClearable
                                    value={value ? value : ""}
                                    sx={{ width: "13.6dvw" }}
                                    size="small"
                                    inputProps={{'emed_tid': 'drg_route' }}
                                    options={statekey === "externalRoute" ? IP_routeList :  (IP_routeList.length > 0 && this.state.pharma_name !== "") ? IP_routeList : []}
                                    // getOptionDisabled={
                                    //     (option) => this.DisableRouteOption(option, IP_routeList)
                                    // }
                                    getOptionLabel={option => typeof (option) === "string" ? option : option.value}
                                    onChange={(event, newRoute) => {
                                        if(statekey === "externalRoute"){
                                            states["externalRoute"] = newRoute?.value
                                            states["externalRouteOther"] = ""
                                            this.setState({
                                              states
                                            })

                                        }else{
                                            this.setState({
                                                route: newRoute.value
                                            })
                                        }
                                     
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t(label)}
                                            autoComplete="off"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                            }}
                                            onFocus={statekey === "externalRoute" && this.handleFocus}
                                        />
                                    )}
                                /> :
                                <TextField
                                    sx={{ width: "13.6dvw" }}
                                    size="small"
                                    autoComplete="off"
                                    inputProps={{ emed_tid: `drg_route${statekey}` }}
                                    label={t(label)}
                                    name={statekey}
                                    value={statekey === "externalRoute" ?value ? states[value] : "" : value ? value : ""}
                                    disabled={isDisabled}
                                    onChange={this.handleChange}
                                />}
            </div>
        )
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    MenuList = (data) => {
        const { t } = this.props
        return (
            <div>
                <Tooltip title={t("More")} placement='top' arrow>
                    <IconButton
                        emed_tid="drg_more_icon"
                        disabled={this.state.withOutAppointment?.is_ip}
                        onClick={(e) => {
                            this.setState({
                                anchorEl: e.currentTarget,
                                selectedRow: data,
                                isSelected: true
                            }, () => { this.handleClear() })
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(this.state.isSelected && this.state.selectedRow.index == data.index) ?
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={() => {
                            this.setState({ anchorEl: null, })
                        }}>
                        {multi_option.map((option) => (
                            <MenuItem key={option} className="eMed_drugMenu"
                                onClick={() => {
                                    this.setState({
                                        anchorEl: null,
                                        selectedMenu: option.value,
                                        Nurse: {
                                            "nurse": data?.nurse || "",
                                            "staff_id": data?.nurse_profile_id || ""
                                        }
                                    },
                                        () => {
                                            if (this.state.selectedMenu === "view_log") {
                                                this._getLogDetails(data.id)
                                            }
                                        })
                                }}
                            >
                                <div className="eMed_drugMenu_item"
                                    style={{
                                        border: option.color === "#FFFFFF" ?
                                            `1px solid #cbbfbf` : option.color !== "" ?
                                                `1px solid ${option.color}` : null,
                                        background: option.color
                                    }}></div>
                                {t(option.label)}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        )
    }

    // view log popup start
    viewLogPopUpClose = () => {
        this.setState({
            anchorEl: null,
            selectedMenu: "",
            viewLogData: []
        })
    }

    _showViewLog(logData) {
        const { t } = this.props;
        const logColumn = [
            {
                field: 'modified_by', headerName: t('ModifiedBy'), sortable: false, hideable: false, flex: 0.25, renderCell: ({ row }) => {
                    return (<div>{row?.modified_by?.length > 28 ?
                        <Tooltip placement="top" title={row?.modified_by} arrow>
                            <div>{row?.modified_by.slice(0, 25) + "..."}</div></Tooltip>
                        : row?.modified_by ? row?.modified_by : "-"}</div>)
                }
            },
            {
                field: 'modified_date', headerAlign: "center", headerName: t('ModifiedDateAndTime'), align: "center", sortable: false, hideable: false, flex: 0.25, renderCell: ({ row }) => {
                    return (<Typography>{row?.modified_date ? formatDateAndTimeMeth2(row?.modified_date) : "-"}</Typography>)
                }
            },
            {
                field: 'status', headerName: `${t('Previous Status')}`, flex: 0.25, sortable: false, hideable: false, renderCell: ({ row }) => {
                    return (<div>{row?.status?.length > 30 ?
                        <Tooltip placement="top" title={row?.status} arrow>
                            <div>{row?.status.slice(0, 26) + "..."}</div></Tooltip>
                        : row?.status ? row?.status : "-"}</div>)
                }
            },
            {
                field: 'comments', headerName: `${t('Reason')}`, flex: 0.25, sortable: false, hideable: false, renderCell: ({ row }) => {
                    return (<div>{row?.comments?.length > 30 ?
                        <Tooltip placement="top" title={row?.comments} arrow>
                            <div>{row?.comments.slice(0, 26) + "..."}</div></Tooltip>
                        : row?.comments ? row?.comments : "-"}</div>)
                }
            }
        ];

        return (
            <Box id="eMed_ipsrvConfig_accTbl">
                <DataGrid
                    rows={logData ? logData : []}
                    columns={logColumn}
                    getRowId={(row) => row.modified_date}
                    disableColumnMenu
                    hideFooter
                    components={{
                        NoRowsOverlay: () => {
                            return (
                                <Stack className="eMed_conf_nodata">
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }
                    }}
                    headerHeight={40}
                />
            </Box>
        )
    }


    popupClose = () => {
        this.setState({
            selectedMenu: ""
        })
    }

    addCancelComments = (comments) => {
        this.handleAdd(this.state.selectedMenu, comments)
    }

    // view log popup end

    handleEdit = (data) => {
        let states = this.state
        if (data?.drug_ms_id) {
            this.setState({
                selectedData: data,
                drug_date: data?.date ? dayjs(data?.date) : dayjs(),
                drug_name: data?.drug_name,
                generic_name: data?.generic_name,
                dosage_type: data?.dosage_type,
                dosage_strength: data?.dosage_strength,
                route: data?.route,
                quantity: data?.quantity,
                frequency: data?.frequency,
                instruction: data?.instruction,
                isEdit: true,
                ExternalDrug : false,
                Nurse: {
                    "nurse": data?.nurse || "",
                    "staff_id": data?.nurse_profile_id || ""
                }
            })
        } else {
            this.setState({
                ExternalDrug : true,
                externalBrandName : data.drug_name,
                externalGenName : data.generic_name,
                externalDosageType : data.dosage_type,
                externalDosStrength : data.dosage_strength,
                externalRoute : data.route,
                external_quantity: data?.quantity,
                external_frequency: data?.frequency,
                external_instruction: data?.instruction,
                isEdit: true,
                selectedData: data,
                drug_date: data?.date ? dayjs(data?.date) : dayjs(),
                Nurse: {
                    "nurse": data?.nurse || "",
                    "staff_id": data?.nurse_profile_id || ""
                },
                fo_external_drug_id: data?.fo_external_drug_id || null,
            })

        }
        this.setState({
            states,
             genericList: []
          }, () => {
          })

    }

    checkDataPresence = () => {
        let fieldsToCheck = []
        if(this.state.ExternalDrug){
             fieldsToCheck = [
                "externalBrandName" ,'externalGenName', 'externalDosageType',
                'externalDosStrength'
            ];

        }else{
             fieldsToCheck = [
                'drug_ms_id', 'generic_name', 'dosage_type',
                'dosage_strength'
            ];

        }
      

        const isDataPresent = fieldsToCheck.every(field => {
            const value = this.state[field];
            return value !== null && value !== "" && value !== undefined;
        });

        return ((this.state.drug_name || this.state.externalBrandName) && isDataPresent);
    }

    NurseSelection = () => {
        return (
            <div>
            <Autocomplete
                size='small'
                sx={{width: "13.6vw"}}
                options={this.state.NurseList}
                getOptionLabel={(option) => option.nurse}
                value={this.state.Nurse}
                onChange={(event, newValue) => {
                    this.setState({
                        Nurse: newValue
                    })
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={"Name of The Nurse"}
                        placeholder={"Name of The Nurse"}
                    />
                )}
            />
            </div>
        )
    }

    postNewTemplateData = () => {
        try {
            this.setState({ templateLoad: true });

            const { tblData, tempType, clinic_id, templateName, renameTemplateName } = this.state;

            // get line_items if rename
            const existingLineItems = tempType === "rename" ? renameTemplateName?.line_items || [] : [];

            const templateList = tblData?.map((item) => {
                // find match by drug_name
                const existingItem = existingLineItems?.find(
                    (line) => line?.drug_name?.toLowerCase() === item?.drug_name?.toLowerCase() &&
                        line?.dosage_strength?.toLowerCase() === item?.dosage_strength?.toLowerCase() &&
                        line?.dosage_type?.toLowerCase() === item?.dosage_type?.toLowerCase() &&
                        line?.generic_name?.toLowerCase() === item?.generic_name?.toLowerCase()
                );

                return {
                    "id": existingItem ? existingItem.id : null,
                    "drug_name": item?.drug_name || "",
                    "generic_name": item?.generic_name || "",
                    "dosage_strength": item?.dosage_strength || "",
                    "dosage_type": item?.dosage_type || "",
                    "route": item?.route || "",
                    "quantity": item?.quantity || "",
                    "frequency": item?.frequency || "",
                    "instruction": item?.instruction || "",
                    "comments": item?.comments || "",
                    "status": item?.status || "Start",
                    "fo_external_drug_id": item?.fo_external_drug_id || null,
                    "is_external_drug": item?.fo_external_drug_id ? true : false,
                    "nurse_profile_id": item?.nurse_profile_id || null,
                }})

            const data = {
                "template_name": templateName,
                "data": templateList || [],
                "clinic_id": clinic_id || undefined,
                "template_id": renameTemplateName?.template_id || undefined,
            }
            RestAPIService.create(data, Serviceurls.IP_DRUG_CHART_TEMPLATE)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            openPopupAddNew: false,
                            templateName: '',
                            selectedTemplateName: '',
                            templateLoad: false,
                            renameTemplateName: {},
                            tempType: '',
                        })
                        this.getTemplateList()
                        this.successMsgFunc(response.data.message)
                    } else {
                        this.errorMsgFunc(response.data.message)
                    }
                }).catch(error => {
                    this.errorMsgFunc(error.response?.data?.message || error.message)
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        } finally {
            this.setState({ templateLoad: false })
        }
    }

    deleteTemplate = () => {
        try {
            this.setState({ deleteLoad: true })
            RestAPIService.delete(Serviceurls.IP_DRUG_CHART_TEMPLATE, { "template_ids": [this.state.deleteTemplateName?.template_id] })
                .then((response) => {
                    this.successMsgFunc(response.data.message)
                    this.setState({
                        openPopupAddNew: false,
                        deleteTemplateName: {},
                        selectedTemplateName: '',
                        deletePopup: false,
                        deleteLoad: false,
                    })
                    this.getTemplateList()
                }).catch((error) => {
                    this.setState({ deleteLoad: false })
                    this.errorMsgFunc(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            this.setState({ deleteLoad: false })
            this.errorMsgFunc(error.message)
        }
    }

    renderTemplate = () => {
        const { templateList, selectedTemplateName } = this.state;
        const onChange = (e, value) => {
            this.setState({ selectedTemplateName: value },
                () => {
                    if (!value) return;
                    const data = value?.line_items?.map(({ id, ...item }) => ({
                        ...item,
                        'ip_admission_id': this.state?.patientData?.id,
                        "doctor_id": this.state?.patientData?.doctor_id,
                        'date': this.formatDate(new Date()),
                        'status_update': false,
                    }))
                    this.handleAdd("Start", "", data)
                })
        }

        const onDelete = (e, option) => {
            e.stopPropagation();
            this.setState({
                tempType: 'delete',
                deleteTemplateName: option,
                deletePopup: true
            });
        }

        const onRename = (e, option) => {
            e.stopPropagation();
            this.setState({
                openPopupAddNew: true,
                tempType: 'rename',
                templateName: option?.template_name,
                renameTemplateName: option
            })
        }

        const onAddTemplate = (e) => {
            this.setState({
                openPopupAddNew: true,
                tempType: 'Add',
                selectedTemplateName: null,
                templateName: '',
                renameTemplateName: {},
            })
        }
        const disableSlct = (this.state.tblData?.length === 0 && templateList?.length === 0);
        const checkuserAccess = this.props.is_From_IpNotes ? disableSlct : CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Drug Chart", "SubTab")?.editAccess ?
            this.state.withOutAppointment?.is_ip || disableSlct : true;

        return (
            <Autocomplete
                clearIcon
                size='small'
                disabled={checkuserAccess}
                sx={{ width: '16vw' }}
                options={templateList || []}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name || ""}
                isOptionEqualToValue={(option, value) => option.template_id === value?.template_id}
                value={selectedTemplateName || null}
                onChange={onChange}
                renderOption={(props, option) => {
                    return (
                        <li {...props} style={{ padding: "0vh 1.5vh" }}>
                            <ListItem sx={{ display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }}>
                                <ListItemText primary={option?.template_name && option?.template_name?.length > 25 ?
                                    <Tooltip placement='top' title={option?.template_name}>{<div>{option?.template_name?.slice(0, 18) + '...'}</div>}</Tooltip>
                                    : option?.template_name} />
                                <Box sx={{display: "flex", alignItems: "center", gap: "0.5vw"}}>
                                    <IconButton
                                        edge="end"
                                        color="primary"
                                        onClick={(e) => onRename(e, option)}
                                    >
                                        <Tooltip placement='top' title={"Rename"} arrow>
                                            <EditIcon sx={{ height: "2.5vh", width: "2.5vw" }} /> </Tooltip>
                                    </IconButton>
                                    <IconButton
                                        edge="end"
                                        color="error"
                                        onClick={(e) => onDelete(e, option)}
                                    >
                                        <Tooltip placement='top' title={"Delete"} arrow>
                                            <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} /> </Tooltip>
                                    </IconButton>
                                </Box>
                            </ListItem>
                        </li>
                    );
                }}
                renderInput={(params) => <TextField
                    {...params}
                    label='Select Template'
                />}
                PaperComponent={({ children }) => {
                    return (
                        <Paper sx={{ maxHeight: '25vw', overflow: 'scroll' }}>
                            {children}
                            <Divider />
                            <Button
                                color="primary"
                                fullWidth
                                disabled = {this.state.tblData?.length === 0}
                                sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                                onMouseDown={onAddTemplate}
                            >
                                Add Template
                            </Button>
                        </Paper>
                    )
                }}
            />
        )
    }

    renderTemplatePopup = () => {
        try {
            const { openPopupAddNew, tempType, templateName, templateLoad } = this.state;
            const title = titleMap[tempType] || "Template";

            const closePopup = () => this.setState({ openPopupAddNew: false, templateName: "" });

            return (
                <Modal open={openPopupAddNew}
                    keepMounted
                    disableEnforceFocus
                    styles={{
                        content: {
                            outline: "none",
                            boxShadow: "none",
                        },
                    }}>
                    <Box className="eMed_Doc_Notes_Prescrip_Fav_Pop_Up">
                        {/* Header */}
                        <Box display="flex" justifyContent="space-between" p="0.5vw" alignItems="center">
                            <Typography fontSize="0.9vw" fontWeight={600}> {title} </Typography>
                            <Button className="Common_Btn_Min_Width" onClick={closePopup}>
                                <Box
                                    component="img"
                                    src={ImagePaths.LabCloseButton.default}
                                    height="1.1vw"
                                    width="1.1vw"
                                />
                            </Button>
                        </Box>

                        {/* Input */}
                        <Box ml="2.5vw">
                            <TextField
                                size="small"
                                sx={{ width: "20vw" }}
                                label="Enter Template Name*"
                                autoComplete="off"
                                inputProps={{ maxLength: 50 }}
                                value={templateName}
                                onChange={(e) => this.setState({ templateName: e.target.value })}
                            />
                        </Box>

                        {/* Footer Actions */}
                        <Box display="flex" justifyContent="center" alignItems="center" height="3vw" gap="1vw">
                            <Button
                                sx={{ height: "2vw", width: "5vw", textTransform: "capitalize" }}
                                variant="outlined"
                                onClick={() => this.setState({ templateName: "" })}
                            >
                                Clear
                            </Button>
                            <Button
                                sx={{ height: "2vw", width: "5vw", textTransform: "capitalize" }}
                                variant="contained"
                                onClick={this.postNewTemplateData}
                                disabled={!templateName?.trim() || templateLoad}
                            >
                                Add
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            );
        } catch (error) {
            this.errorMessage(error.message);
        }
    };

    render() {
        const { t } = this.props;
        let states = this.state;
        const checkuserAccess = CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Drug Chart", "SubTab")?.editAccess ?
            this.state.withOutAppointment?.is_ip : true;
        let myUser = JSON.parse(localGetItem("loggedInUserInfo"));

        const currentDate = dayjs();
        const admissionDate = states?.patientData?.admitted_date
            ? dayjs(states.patientData?.admitted_date)
            : states?.patientData?.admission_date
                ? dayjs(states.patientData?.admission_date)
                : currentDate;
        let dischargeDate = currentDate;
        if (states.patientData?.discharge_date) {
            const dischargeRaw = states.patientData.discharge_date;
            dischargeDate = dischargeRaw.length > 10
                ? dayjs(dischargeRaw)
                : dayjs(dischargeRaw).endOf('day');
            if (dischargeDate.isAfter(currentDate)) {
                dischargeDate = currentDate;
            }
        }

        const columns = [
            {
                field: 'date', headerName: t('Date & Time'), flex: 0.1, renderCell: ({ row }) => {
                    return (
                        <div>{row?.date?.length > 8 ?
                            <Tooltip placement="top" title={formatDateAndTimeMeth2(row?.date || "")} arrow>
                                <div>{formatDateAndTimeMeth2(row?.date).slice(0, 8) + "..."}</div>
                            </Tooltip>
                            : row?.date ? formatDateAndTimeMeth2(row?.date) : "-"}</div>
                    )
                }
            },
            {
                field: 'dosage_type', headerName: t('Dosage type'), flex: 0.1, renderCell: ({ row }) => {
                    return (
                        <div>{row?.dosage_type?.length > 8 ?
                            <Tooltip placement="top" title={row?.dosage_type} arrow>
                                <div>{row?.dosage_type.slice(0, 6) + "..."}</div>
                            </Tooltip>
                            : row?.dosage_type ? row?.dosage_type : "-"}</div>
                    )
                }
            },
            {
                field: 'drug_name', headerName: t('Drug Name'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div style={{ fontWeight: row?.is_high_alert && this.state.enable_drug_alert? '600' : 'inherit', color: row?.is_high_alert && this.state.enable_drug_alert ? 'red' : 'inherit' }}>
                        {row?.drug_name?.length > 8 ?
                            <Tooltip placement="top" title={row?.drug_name} arrow>
                                <div>{row?.drug_name.slice(0, 6) + "..."}</div></Tooltip>
                            : row?.drug_name ? row?.drug_name : "-"}
                    </div>
                    )
                }
            },
            {
                field: 'dosage_strength', headerName: t('Dosage Strength'), headerAlign: "center", align: "center", flex: 0.1,
                renderCell: ({ row }) => {
                    return (<div>{row?.dosage_strength?.length > 8 ?
                        <Tooltip placement="top" title={row?.dosage_strength} arrow>
                            <div>{row?.dosage_strength.slice(0, 6) + "..."}</div></Tooltip>
                        : row?.dosage_strength ? row?.dosage_strength : "-"}</div>
                    )
                }
            },
            {
                field: 'route', headerName: t('Route'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div>{row?.route?.length > 8 ?
                        <Tooltip placement="top" title={row?.route} arrow>
                            <div>{row?.route.slice(0, 6) + "..."}</div></Tooltip>
                        : row?.route ? row?.route : "-"}</div>)
                }
            },
            {
                field: 'frequency', headerName: t('Frequency'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div>{row?.frequency?.length > 8 ?
                        <Tooltip placement="top" title={row?.frequency} arrow>
                            <div>{row?.frequency.slice(0, 6) + "..."}</div></Tooltip>
                        : row?.frequency ? row?.frequency : "-"}</div>)
                }
            },
            {
                field: 'instruction', headerName: t('Instruction'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div>{row?.instruction?.length > 8 ?
                        <Tooltip placement="top" title={row?.instruction} arrow>
                            <div>{row?.instruction.slice(0, 6) + "..."}</div></Tooltip>
                        : row?.instruction ? row?.instruction : "-"}</div>)
                }
            },
            {
                field: 'doctor_name', headerName: t('Doctor Name'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div>{row?.doctor_name?.length > 10 ?
                        <Tooltip placement="top" title={row?.doctor_name} arrow>
                            <div>{row?.doctor_name.slice(0, 10) + "..."}</div></Tooltip>
                        : row?.doctor_name ? row?.doctor_name : "-"}</div>)
                }
            },
            {
                field: 'nurse', headerName: t('Nurse Name'), flex: 0.1, renderCell: ({ row }) => {
                    return (<div>{row?.nurse?.length > 8 ?
                        <Tooltip placement="top" title={row?.nurse} arrow>
                            <div>{row?.nurse.slice(0, 8) + "..."}</div></Tooltip>
                        : row?.nurse ? row?.nurse : "-"}</div>)
                }
            },
            {
                field: "action", flex: 0.1, headerName: t("Action"), headerAlign: "center", align: "center",
                sortable: false, hideable: false,
                renderCell: ({ row }) => {
                    const isDocCanEdit = this.props.is_From_IpNotes ? !(myUser?.doctor_id === row?.doctor_id) : checkuserAccess;
                    return (<Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                        <CommonEditButton testID={"drg_edit_btn"} size={"1.5vw"} disable={isDocCanEdit} onClick={this.handleEdit.bind(this, row)} />
                        {this.MenuList(row)}
                    </Box>)
                }
            }
        ]

        let data = {
            lineOne: t("AttenderName"),
            lineTwo: `${states["attenderData"]["attender_name"] ? states["attenderData"]["attender_name"] : "-"}`,
            lineFour: t('ContactNumber'),
            LineFive: `${states["attenderData"]["attender_mobile"] ? states["attenderData"]["attender_mobile"] : "-"}`
        }

        let Consultant = {
            image: ImagePaths.Doctor_Icon.default,
            width: "2.3vw",
            height: "2.3vw",
            lineOne: t("ConsultantName"),
            lineTwo: `${states["attenderData"]["doctor_name"] ? states["attenderData"]["doctor_name"] : "-"}`
        }
        return (
            <Box id="eMed_medication_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container className="eMed_medication_Box" >
                    <Stack className="eMed_medicationCard_header" direction="row" justifyContent="space-evenly" alignItems="center" spacing={1.2} >
                        <Stack className="eMed_recCard_div" sx={{ width: "23vw", backgroundColor: Colors.white }} >
                            <CommonPatientDetails data={this.state.patientData} showDetailed={true} />
                        </Stack>
                        <CommonPatientCard details={data} showDetailed={true} />
                        <ConsultantPatientCard name={Consultant} width={"20dvw"} />
                        {this.renderTemplate()}
                    </Stack>
                    <Grid container item spacing={2} className="eMed_medication_mainDiv">
                        <Grid item xs={8}>
                            <Paper className="eMed_medication_Div" elevation={2}>
                                <DataGrid
                                    rows={states["tblData"]}
                                    columns={columns}
                                    getRowId={(row) => row.id}
                                    disableSelectionOnClick={true}
                                    localeText={{
                                        toolbarColumns: "",
                                        toolbarDensity: "",
                                        toolbarExport: "",
                                        toolbarFilters: "",
                                        toolbarExportPrint: ""
                                    }}
                                    components={{
                                        Toolbar: CommonGridHeader.CommonToolBar,
                                        NoRowsOverlay: () => (
                                            <Stack className='eMed_conf_nodata'>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }}
                                    headerHeight={40}
                                    rowCount={states["tblData"].length}
                                    page={states["current_page"]}
                                    onPageChange={(newPage) => this.setState({ current_page: newPage })}
                                    pageSize={states["rowsPerPage"]}
                                    onPageSizeChange={(newPageSize) => this.setState({ rowsPerPage: newPageSize })}
                                    rowsPerPageOptions={[10, 20, 30]}
                                    pagination
                                    getRowClassName={({ row }) => {
                                        switch (row.status) {
                                            case 'Start':
                                                return 'eMed_drug_status_start';
                                            case 'Stop':
                                                return 'eMed_drug_status_stop';
                                            case 'Hold':
                                                return 'eMed_drug_status_hold';
                                            case 'Completed':
                                                return 'eMed_drug_status_Completed';
                                            default:
                                                return '';
                                        }
                                    }}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={4}>
                            <Paper className="eMed_medication_Div" elevation={2}>
                                <div className="eMed_lab_subDiv">
                                    <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                        <p className='eMed_recPayment_rightHead_txt'>{t("Drug Chart")}</p>
                                        {this.renderTextBox("SelectPharmacy", "pharma_name", states["pharma_name"])}
                                    </div>
                                    <Box>
                                        <Box sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw" }}>
                                            <Button size="small" variant="outlined" onClick={() => { this.setState({ ExternalDrug: !this.state.ExternalDrug }) }}>{this.state.ExternalDrug ? "Pharmacy Drugs" : "External drugs"}</Button>
                                        </Box>
                                    </Box>
                                    <Stack className="emedhub_medication_RightContentBox" direction="column" justifyContent="center" alignItems="flex-start" spacing={0.5}>
                                        <Box component={'div'} className='eMed_DocNotes_DateTime' sx={{ backgroundColor: Colors.ThemeLightColor, margin: "0.1dvw 0.5dvw !important" }} >
                                            <Typography marginLeft={'0.5vw'} color='#616161' fontWeight={'600'}>{t("Date & Time")}</Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DateTimePicker
                                                    inputFormat='DD-MM-YYYY & hh:mm A'
                                                    value={this.state.drug_date}
                                                    inputProps={{ 'emed_tid': 'drg_drug_date' }}
                                                    onChange={(newDate) => {
                                                        const now = dayjs();
                                                        if (!newDate || dayjs(newDate).isAfter(now)) {
                                                            this.setState({ drug_date: now.toDate() });
                                                        } else {
                                                            this.setState({ drug_date: dayjs(newDate).toDate() });
                                                        }
                                                    }}
                                                    minDateTime={admissionDate}
                                                    maxDateTime={dischargeDate}
                                                    renderInput={(params) =>
                                                        <TextField size='small'
                                                            {...params}
                                                            fullWidth
                                                            variant='standard'
                                                            className='eMed_DocNotes_datePic_Textfield'
                                                        />}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                        {
                                          this.state.ExternalDrug ? 
                                          <div className="eMed_drugRight_txtDiv">
                                             {this.renderTextBox("Drug Name", "externalBrandName", states["externalBrandName"], false, true)}
                                             {this.renderTextBox("Generic Name *", "externalGenName", states["externalGenName"], false, true)}
                                             {this.renderTextBox("Dosage Type *", "externalDosageType", states["externalDosageType"], true,true)}
                                             {this.renderTextBox("Dosage Strength *", "externalDosStrength", states["externalDosStrength"], false ,true)}
                                             {this.renderTextBox("Route", "externalRoute", states["externalRoute"], false, true)}
                                             {this.renderTextBox("Quantity", "external_quantity", states["external_quantity"], false, true)}
                                             {this.renderTextBox("Frequency", "external_frequency", states["external_frequency"], false, true)}
                                             {this.renderTextBox("Instruction", "external_instruction", states["external_instruction"], false, true)}
                                            <Box>{this.NurseSelection()}</Box>
                                          </div>:
                                             <div className="eMed_drugRight_txtDiv">
                                             {this.renderTextBox("Drug Name", "drug_name", states["drug_name"])}
                                             {this.renderTextBox("Generic Name *", "generic_name", states["generic_name"])}
                                             {this.renderTextBox("Dosage Type *", "dosage_type", states["dosage_type"], true)}
                                             {this.renderTextBox("Dosage Strength *", "dosage_strength", states["dosage_strength"], true)}
                                             {this.renderTextBox("Route", "route", states["route"])}
                                             {this.renderTextBox("Quantity", "quantity", states["quantity"])}
                                             {this.renderTextBox("Frequency", "frequency", states["frequency"])}
                                             {this.renderTextBox("Instruction", "instruction", states["instruction"])}
                                             <Box>{this.NurseSelection()}</Box>
                                         </div>
                                        }
                                     
                                    </Stack>
                                </div>
                                <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                    <Button variant='outlined' disabled={this.state.withOutAppointment?.is_ip} size="small" id="eMed_recPayment_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                    <Button
                                        disabled={checkuserAccess || this.state.isAdd || !this.checkDataPresence()}
                                        variant='contained' size="small" id="eMed_recPayment_btn"
                                        onClick={() => {
                                            this.setState({ isAdd: true, },
                                                () => { this.handleAdd() })
                                        }}>{t("Add")}</Button>
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {
                    (this.state.selectedMenu === "view_log") ?
                        <CommonPopUp width={"75vw"}
                            backgroundColor={Colors.white}
                            popUpClose={this.viewLogPopUpClose.bind(this)}
                            title={t("Log")}
                            component={this._showViewLog.bind(this, states?.viewLogData)} />
                        : null
                }

                {(this.state.selectedMenu && this.state.selectedMenu !== "view_log") ?
                    <ReasonPopup
                        title={t('Reason')}
                        AlertPopupClose={this.popupClose.bind(this)}
                        label={t('Write reason here')}
                        btntext={t('Cancel')}
                        btnvarient={'outlined'}
                        btntext1={t('Save')}
                        btnvarient1={'contained'}
                        sendCmt={this.addCancelComments.bind(this)}
                    /> : null}
                {this.renderTemplatePopup()}
                {this.state.deletePopup ? <DeletePopup
                    DeletTitle={`Are you sure you want to delete ${this.state.tempType === 'delete' ? this.state.deleteTemplateName?.template_name : ''} ?`}
                    deleteAlertPopupClose={() => this.setState({ deletePopup: false, deleteTemplateName: {} })}
                    removeData={this.deleteTemplate.bind(this)}
                    disable={this.state.deleteLoad}
                /> : null}
                {this.state.highAlert && this.state.enable_drug_alert ?
                    <HighAlertDrugPopup
                        selectedDrug={this.state.selectedDrug}
                        is_high_alert={this.state.is_high_alert}
                        is_lookAlike={this.state.is_look_alike}
                        is_soundAlike={this.state.is_sound_alike}
                        lookAlikeDrugs={this.state.lookAlikeDrugs}
                        soundAlikeDrugs={this.state.SoundAlikeDrugs}
                        onCancel={this.highAlertpopupClose.bind(this)}
                        onConfirm={this.highAlertpopupConfirm.bind(this)}
                    /> : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
export default withTranslation()(DrugChart);